import { Point } from './point.model';

export class Counting {
  name: string = '';
  color: string = '#ff0000';
  visible: boolean = true;
  active: boolean = true;
  points: Point[] = [];
}
